export const ADD_ONS = {
  careerHighlightsEnabled: 'Career Highlights',
  achievementsEnabled: 'Achievements',
  milestonesEnabled: 'Milestones',
  playerBadgesEnabled: 'Player Badges',
  levelBadgesEnabled: 'Level badges (performance-based)',
  awardsEnabled: 'Awards',
  matchParticipationEnabled: 'Match Participation',
  joinTournamentsEnabled: 'Join tournaments',
  joinTeamsEnabled: 'Join teams',
  mediaEnabled: 'Add match videos/photos',
};

export const BADGE_OPTIONS = [
  { code: 'MVP', label: 'MVP', icon: '⭐' },
  { code: 'CLUTCH', label: 'Clutch Finisher', icon: '🔥' },
  { code: 'DEFENDER', label: 'Defense Wall', icon: '🛡️' },
  { code: 'SPEEDSTER', label: 'Speedster', icon: '⚡' },
  { code: 'ALLROUNDER', label: 'All-rounder', icon: '🏏' },
];
